
import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PauseProgram from "../Components/Dashboard/Manage-My-Program/PauseProgram";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthPauseprogram = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <PauseProgram /> : <SessionTimeoutRedirect />
}
export default AuthPauseprogram;


